/**
 * "Oil" icon by Mamank from the Noun Project.
 * - Source: https://thenounproject.com/browse/icons/term/oil/
 * - License: Creative Commons Attribution (CC BY 3.0)
 * - License URL: https://creativecommons.org/licenses/by/3.0/
 */
import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const OilIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      // viewBox="-5.0 -10.0 110.0 135.0"
      viewBox="0 0 100 100">
      <path d="m74 49.27-22.539-38.789c-0.30859-0.51953-0.85156-0.83984-1.4492-0.83984-0.60156 0-1.1719 0.32812-1.4609 0.85156l-22.102 38.02c-2.5781 4.4375-3.9492 9.4883-3.9492 14.617 0 7.5508 3.2188 14.84 8.8203 19.988 5.1406 4.7188 11.68 7.25 18.641 7.25 0.82812 0 1.6602-0.03125 2.5-0.10156 14.039-1.2109 25.039-13.512 25.039-28 0-4.5664-1.2109-9.0664-3.5-12.996zm-26.23 31.59c-0.14844 0.46094-0.57812 0.75-1.0508 0.75-0.10938 0-0.23047-0.011719-0.35156-0.058594-2.5-0.83984-6.1406-2.5898-9.2617-6.1602-2.1719-2.4805-3.75-5.4805-4.5781-8.6797-0.14844-0.58984 0.21094-1.1914 0.78906-1.3398 0.58984-0.14844 1.1914 0.19922 1.3398 0.78906 0.73828 2.8594 2.1602 5.5586 4.1016 7.7695 2.8008 3.1992 6.0703 4.7695 8.3086 5.5195 0.58203 0.21094 0.89453 0.83984 0.70312 1.4102z" />
    </SvgIcon>
  );
};

export default OilIcon;
